import {EstateCard, EstateCardProps, EstateCardViewModeType} from "../../EstateCard/EstateCard";
import React from "react";

export type TrustDistributionsLayerProps = {
    estateCardProps: EstateCardProps[][],
    viewMode: EstateCardViewModeType,
    selectedCardId?: string,
    selectedCardRef?: React.RefObject<HTMLDivElement>
}

const TrustDistributionLayer = ({estateCardProps, viewMode, selectedCardRef, selectedCardId}: TrustDistributionsLayerProps) => {
    return (<div className={`trust-distributions-layer ${viewMode}-view-grid-gap`} data-testid={"trust-distributions-layer"}>
        {
            estateCardProps.map((estateCardGroup, groupIndex) => (
                <div key={`group-${estateCardGroup[0]?.estateItem.id}-${groupIndex}`}
                     className={`trust-distribution-group ${viewMode}-view-grid-gap`}>
                    {
                        estateCardGroup.map((estateCard) => (
                            <EstateCard key={`estatecard-${estateCard.estateItem.id}-${estateCard.estateItem.id}`}
                                        viewMode={estateCard.viewMode}
                                        estateItem={estateCard.estateItem}
                                        selectedCardRef={selectedCardRef}
                                        isCardSelected={selectedCardId === estateCard.estateItem.id}
                            />
                        ))
                    }
                </div>
            ))
        }
    </div>);
}

export default TrustDistributionLayer;